import React from "react";
import { Helmet } from "react-helmet-async";
import styled from "styled-components/macro";

import Form from "./Form";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default function ChangePassword() {
  return (
    <Wrapper>
      <Helmet title="Change Password" />
      <Form />
    </Wrapper>
  );
}
